import {
  onDisabledLitiModalidad,
  onLoadAdscripcionSelected,
  onLoadCarpetaJudicial,
  onLoadDatosBusquedaCarpeta,
  onLoadInstanciasOficialia,
  onLoadInstanciasOrdinariasEnLinea,
  onLoadJuzgado,
  onLoadJuzgadosOrdinariosEnLinea,
  onLoadMaterias,
  onLoadMateriaSelected,
  onLoadMateriasOficialia,
  onLoadTipoPenal,
  onLoadTiposCarpetas,
  onLoadVideoAyuda,
  onResetBusquedaCarpeta,
  onResetCarpetaJudicial,
  onSelectExpediente,
} from "store/serviciosGenerales/generalesSlice";
import {
  getCarpetaJudicial,
  getInstanciaOficialia,
  getInstanciasOrdinariasEnLinea,
  getJuzgadosOrdinariosEnLinea,
  getJuzgadosService,
  getJuzgadosAutorizadosService,
  getMateriaOficialia,
  getMateriasInstancias,
  getMateriasOrdinariasEnLinea,
  getTiposNumeros,
  getJuzgadosIndicesService,
  getFechasLiberacionJuiciosVigentes,
  getVideoTutorialActivo,
} from "services/serviciosGenerales/serviciosGenerales";
import { useAppDispatch, useAppSelector } from "./reduxHooks";
import {
  SolicitudCarpetaJudicial,
  SolicitudJuzgadosOrdinariosEnLinea,
} from "interfaces/serviciosGenerales/serviciosGeneralesInterface";
import { listaErrores } from "helpers/helpers";
import { setIsLoading } from "store";
import Swal from "sweetalert2";
import moment from "moment";

export const useGeneralStore = () => {
  const dispatch = useAppDispatch();

  const {
    tipoPenal,
    lstJuzgados,
    lstMateriasOr,
    lstInstanciasOr,
    carpetaJudicial,
    materiaSelected,
    lstTiposCarpetas,
    materiasOficialia,
    instanciasOficialia,
    adscripcionSelected,
    juzgadosOrdinariosEnLinea,
    datosBusquedaCarpetaJudicial,
    expedienteSelect,
    videoAyuda,
  } = useAppSelector((state) => state.generales);

  const setTipoPenal = () => {
    dispatch(onLoadTipoPenal());
  };

  const resetCarpetaJudicial = () => {
    dispatch(onResetBusquedaCarpeta());
  };

  const startGetJuzgados = () => {
    getJuzgadosService()
      .then(({ data }) => {
        dispatch(onLoadJuzgado(data.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const startGetJuzgadosAutorizados = () => {
    getJuzgadosAutorizadosService()
      .then(({ data }) => {
        dispatch(onLoadJuzgado(data.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const startGetJuzgadosIndice = () => {
    getJuzgadosIndicesService()
      .then(({ data }) => {
        dispatch(onLoadJuzgado(data.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const setMateriasInstancia = (materias: any) => {
    dispatch(onLoadMaterias(materias));
  };

  const startGetInstanciasOficialia = (
    cveOficialia: number,
    cveMateria: number
  ) => {
    getInstanciaOficialia(cveOficialia, cveMateria)
      .then(({ data }) => {
        dispatch(onLoadInstanciasOficialia(data.data));
      })
      .catch((err) => {
        console.log(err);
        dispatch(onLoadInstanciasOficialia([]));
      });
  };

  const startGetJuzgadosOrdinariosEnLinea = (
    body: SolicitudJuzgadosOrdinariosEnLinea
  ) => {
    getJuzgadosOrdinariosEnLinea(body)
      .then(({ data }) => {
        dispatch(onLoadJuzgadosOrdinariosEnLinea(data.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const setAdscripcionSelected = (cveAds: number) => {
    dispatch(onLoadAdscripcionSelected(cveAds));
  };

  const startGetTiposCarpetas = (cveMateria: number) => {
    dispatch(onLoadTiposCarpetas([]));
    getTiposNumeros(cveMateria)
      .then(({ data }) => {
        dispatch(onLoadTiposCarpetas(data.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const startGetMateriasOficialia = (cveOficialia: number) => {
    dispatch(onLoadMateriasOficialia([]));
    getMateriaOficialia(cveOficialia)
      .then(({ data }) => {
        dispatch(onLoadMateriasOficialia(data.data));
      })
      .catch((err) => {
        dispatch(onLoadMateriasOficialia([]));
        console.log(err);
      });
  };

  const startGetMateriasInstancias = (cveAdscipcion: number) => {
    dispatch(onLoadInstanciasOrdinariasEnLinea([]));
    getMateriasInstancias(cveAdscipcion)
      .then(({ data }) => {
        dispatch(onLoadInstanciasOrdinariasEnLinea(data.data));
      })
      .catch((err) => {
        console.log(err);
        dispatch(onLoadInstanciasOrdinariasEnLinea([]));
        dispatch(onLoadMaterias([]));
      });
  };

  const startGetMateriasOrdinariasEnLinea = (enLinea: string) => {
    dispatch(onLoadMaterias([]));
    getMateriasOrdinariasEnLinea(enLinea)
      .then(({ data }) => {
        dispatch(onLoadMaterias(data.data));
        dispatch(onLoadJuzgadosOrdinariosEnLinea([]));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const startGetInstanciasOrdinariasEnLinea = (enLinea: string) => {
    getInstanciasOrdinariasEnLinea(enLinea)
      .then(({ data }) => {
        dispatch(onLoadInstanciasOrdinariasEnLinea(data.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const startGetVideoAyuda = () => {
    getVideoTutorialActivo()
      .then(({ data }) => {
        dispatch(onLoadVideoAyuda(data.data));
      })
      .catch((err) => {
        dispatch(onLoadVideoAyuda(null));
        console.log(err);
      });
  };
  const resetVideoAyuda = () => {
    dispatch(onLoadVideoAyuda(null));
  };

  const startGetFechasLiberacionJuicios = (fechaRegistro: string) => {
    getFechasLiberacionJuiciosVigentes()
      .then(({ data }) => {
        const fechaLiberacion = moment(data.data.date);
        const fecha_registro = moment(fechaRegistro);
        if (fecha_registro.isBefore(fechaLiberacion)) {
          dispatch(
            onDisabledLitiModalidad({
              cveLitiDisabled: true,
              cveModalidadDisabled: true,
              fechaLiberacion,
            })
          );
        } else {
          dispatch(
            onDisabledLitiModalidad({
              cveLitiDisabled: false,
              cveModalidadDisabled: false,
              fechaLiberacion,
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const startGetCarpetaJudicial = (body: SolicitudCarpetaJudicial) => {
    dispatch(setIsLoading(true));
    getCarpetaJudicial(body)
      .then(({ data }) => {
        dispatch(onLoadDatosBusquedaCarpeta(body));
        dispatch(onLoadCarpetaJudicial(data.data));
      })
      .catch((err) => {
        dispatch(setIsLoading(false));
        Swal.fire({
          title: `Ha ocurrido un error al guardar el reporte`,
          text: err?.response?.data?.error_msg || "Hubo un problema",
          icon: "warning",
          confirmButtonText: "Aceptar",
          confirmButtonColor: "#6e7881",
          html: `
          <style>
          h4, h5{
            font-family: arial;
            color: #545454;
          }
        </style>
          <h4>${err?.response?.data?.data || "Hubo un problema"}</h4>
          <h5>${err?.response?.data?.error_data || "Hubo un problema"}</h5>
          <div id="lista-errores"></div>
         `,
        });
        listaErrores(err);
      });
  };

  const setMateriaSelected = (value: number) => {
    dispatch(onLoadMateriaSelected(value));
  };

  const resetFormCarpetas = () => {
    dispatch(onResetCarpetaJudicial());
  };

  const setDatosBusquedaCarpeta = (value: SolicitudCarpetaJudicial) => {
    dispatch(onLoadDatosBusquedaCarpeta(value));
  };
  const setExpedienteSelected = (value: any) => {
    dispatch(onSelectExpediente(value));
  };

  return {
    /**Propiedades **/
    tipoPenal,
    lstJuzgados,
    lstMateriasOr,
    lstInstanciasOr,
    materiaSelected,
    carpetaJudicial,
    lstTiposCarpetas,
    materiasOficialia,
    instanciasOficialia,
    adscripcionSelected,
    juzgadosOrdinariosEnLinea,
    datosBusquedaCarpetaJudicial,
    expedienteSelect,
    videoAyuda,
    /** Métodos **/
    setTipoPenal,
    startGetJuzgados,
    startGetJuzgadosAutorizados,
    resetFormCarpetas,
    setMateriaSelected,
    resetCarpetaJudicial,
    setMateriasInstancia,
    startGetTiposCarpetas,
    setAdscripcionSelected,
    startGetCarpetaJudicial,
    setDatosBusquedaCarpeta,
    startGetMateriasOficialia,
    startGetMateriasInstancias,
    startGetInstanciasOficialia,
    startGetMateriasOrdinariasEnLinea,
    startGetJuzgadosOrdinariosEnLinea,
    startGetJuzgadosIndice,
    startGetInstanciasOrdinariasEnLinea,
    startGetFechasLiberacionJuicios,
    setExpedienteSelected,
    startGetVideoAyuda,
    resetVideoAyuda,
  };
};
